import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<h3 class=\"modal-layout__header-title\">{{this.title}}</h3>\n\n{{#if this.helpText}}\n  <div class=\"modal-layout__header-helptext\">{{this.helpText}}</div>\n{{/if}}", {
  moduleName: "@dashboard/shared-ui/components/deprecated/standard-modal-header.hbs"
});